import TeamStatistics from 'components/general/TeamStatistics'

function BscTeamStats({ data }) {

  const stats = [
    { code: 'POSSESS' }, 
    { code: 'RC' },                                               
    { code: 'YRC'},                                               
    { code: 'YC'},             
    { code: 'OG' },                                             
    { code: 'OHK', component:'type9' },                                              
    { code: 'PTY', component: 'type9' },                                         
    { code: 'FRK'},                         
    { code: 'CRN'},                           
    { code: 'FOC'},                           
    { code: 'SHOT', header:'SHOTG'},  
    { code: 'SHOT', component: 'type9'}                         

  ]
  return (<>
    <TeamStatistics data={data?.results} stats={stats} />
  </>);
}

export default BscTeamStats;